import { render, staticRenderFns } from "./DelegatesListPage.vue?vue&type=template&id=2f1eb274"
import script from "./DelegatesListPage.vue?vue&type=script&lang=ts"
export * from "./DelegatesListPage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports